// components/Pagination.jsx
import React from 'react';
import arrow from '../../../../Assets/Icons/nextIcon.png';

const Pagination = ({ currentPage, setCurrentPage, totalPages, setPageSize }) => (
    <div className="flex items-center justify-end gap-4 mt-4">
        <div>
            Rows per page:
            <select
                onChange={e => {
                    setPageSize(Number(e.target.value));
                    setCurrentPage(1);
                }}
                className="ml-2 px-2 py-1 border rounded"
            >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
            </select>
        </div>
        <div className="text-sm">Page {currentPage} of {totalPages}</div>
        <img
            src={arrow}
            alt='prev'
            onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
            style={{ transform: 'rotate(180deg)' }}
            className={`h-4 w-4 m-2 cursor-pointer ${currentPage === 1 ? 'opacity-30 cursor-not-allowed' : 'hover:scale-110'}`}
        />
        <img
            src={arrow}
            alt='next'
            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
            className={`h-4 w-4 m-2 cursor-pointer ${currentPage === totalPages ? 'opacity-30 cursor-not-allowed' : 'hover:scale-110'}`}
        />
    </div>
);

export default Pagination;
